/**
 * @exports gofor
 * @since 1.1.0
 */

import Gofor from 'gofor';

/**
 * Get the default options for Fiverr's fetch requests
 * @private
 * @return {Object} default request params:
 *
 * @member {Object<String>} credentials Cross origin credentials
 * @member {Object<Object>} headers Headers:
 *   @member {String} 'X-CSRF-Token'     One time query, one place with the logic
 *   @member {String} 'X-Requested-With' Identify as XHR (this helps our server differentiate the requests from full page requests and take decisions based upon that knowledge)
 *   @member {String} 'Content-Type'     Declare content type JSON as default
 *   @member {String} 'Accept'           Requests JSON by default
 */
const getDefaults = () => {
    const headers = defaultHeaders();

    const defaults = {
        credentials: 'same-origin',
        headers,
    };

    return defaults;
};

/**
 * Create the default Headers object
 * @return {Headers}
 */
function defaultHeaders() {
    const headers = new Headers();

    headers.append('X-Requested-With', 'XMLHttpRequest');
    headers.append('Content-Type', 'application/json; charset=utf-8');
    headers.append('Accept', 'application/json');

    try {
        headers.append('X-CSRF-Token', document.AUTH_TOKEN);
    } catch (e) {
        // Fail silently
    }

    return headers;
}

export const gofor = new Gofor(getDefaults).fetch;
